import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { KioskService } from 'src/app/core/services/kiosk.service';
import { OOOrderType } from 'src/app/shared/models/oo-order-type';

@Component({
	selector: 'app-kiosk-checkout',
	templateUrl: './kiosk-checkout.component.html',
	styleUrls: ['../../kiosk.styles.scss'],
})
export class KioskCheckoutComponent implements OnInit, OnDestroy {
	@Input() displayCheckout: boolean;
	@Output() displayCheckoutChange = new EventEmitter<boolean>();

	@Input() checkoutHeader: string;
	@Output() checkoutHeaderChange = new EventEmitter<string>();

	@Input() checkoutHeaderIconPrefix: string;
	@Output() checkoutHeaderIconPrefixChange = new EventEmitter<string>();

	@Input() checkoutHeaderIcon: string;
	@Output() checkoutHeaderIconChange = new EventEmitter<string>();

	@Input() checkoutFooter: string;
	@Output() checkoutFooterChange = new EventEmitter<string>();

	@Input() checkoutFooterIconPrefix: string;
	@Output() checkoutFooterIconPrefixChange = new EventEmitter<string>();

	@Input() checkoutFooterIcon: string;
	@Output() checkoutFooterIconChange = new EventEmitter<string>();

	@Input() checkoutFooterBackDisplay: boolean = true;
	@Output() checkoutFooterBackDisplayChange = new EventEmitter<boolean>();

	checkoutFooterButtonDisabled: boolean = false;

	currentCheckoutStep: string = 'start';

	paymentSuccessSubscription: Subscription;

	constructor(public kioskService: KioskService) {}
	ngOnDestroy(): void {
		throw new Error('Method not implemented.');
	}

	ngOnInit(): void {
		this.paymentSuccessSubscription = this.kioskService.activeOrder.subscribe((order) => {
			if (order.seats[0]?.payments?.length > 0 && order.seats[0]?.payments[0].token) {
				console.log('payment success');
				this.checkoutAdvanceStep();
			}
		});
		this.checkoutAdvanceStep();
	}

	checkoutAdvanceStep() {
		switch (this.currentCheckoutStep) {
			case 'start':
				this.currentCheckoutStep = 'orderTypeSelect';
				break;
			case 'orderTypeSelect':
				this.currentCheckoutStep = 'promoCodeSelect';
				break;
			case 'promoCodeSelect':
				this.currentCheckoutStep = 'identifierInput';
				break;
			case 'identifierInput':
				this.currentCheckoutStep = 'paymentRequest';
				break;
			case 'paymentRequest':
				this.currentCheckoutStep = 'paymentComplete';
				break;
			case 'paymentComplete':
				this.startNewOrder();
				break;
		}

		switch (this.currentCheckoutStep) {
			case 'orderTypeSelect': {
				this.checkoutFooterButtonDisabled = true;
				this.checkoutHeader = 'Where will you be enjoying your food?';
				this.checkoutHeaderIcon = 'plate-utensils';
				this.checkoutHeaderIconPrefix = 'fad';
				this.checkoutFooter = 'Continue';
				this.checkoutFooterIcon = 'arrow-right';
				this.checkoutFooterIconPrefix = 'fad';
				break;
			}
			case 'promoCodeSelect': {
				this.checkoutHeader = 'Do you have any coupons?';
				this.checkoutHeaderIcon = 'badge-dollar';
				this.checkoutHeaderIconPrefix = 'fad';
				this.checkoutFooter = 'Continue';
				this.checkoutFooterIcon = 'arrow-right';
				this.checkoutFooterIconPrefix = 'fad';
				this.checkoutFooterButtonDisabled = false;
				break;
			}
			case 'identifierInput': {
				this.checkoutHeader = 'Tell us how to call out your order';
				this.checkoutHeaderIcon = 'message-quote';
				this.checkoutHeaderIconPrefix = 'fad';
				this.checkoutFooter = 'Continue';
				this.checkoutFooterIcon = 'arrow-right';
				this.checkoutFooterIconPrefix = 'fad';
				this.checkoutFooterButtonDisabled = true;
				this.checkForOrderIdentifier(this.currentCheckoutStep);
				break;
			}
			case 'paymentRequest': {
				this.checkoutHeader = 'Process Payment';
				this.checkoutHeaderIcon = 'credit-card-front';
				this.checkoutHeaderIconPrefix = 'fad';
				this.checkoutFooter = 'Continue';
				this.checkoutFooterIcon = 'arrow-right';
				this.checkoutFooterIconPrefix = 'fad';
				this.checkoutFooterButtonDisabled = true;
				break;
			}
			case 'paymentComplete': {
				this.checkoutHeader = 'Submitting your order!';
				this.checkoutHeaderIcon = 'hat-chef';
				this.checkoutHeaderIconPrefix = 'fad';
				this.checkoutFooter = 'Start New Order';
				this.checkoutFooterIcon = 'arrow-right';
				this.checkoutFooterIconPrefix = 'fad';
				this.checkoutFooterButtonDisabled = false;
				this.checkoutFooterBackDisplay = false;
				break;
			}
		}
	}

	checkForOrderIdentifier(currentCheckoutStep: string) {
		const orderType = this.kioskService.venueService.ooOrderTypes.find((i) => i.key === this.kioskService.activeOrder.value.orderType);
		if (!orderType.identifierNameOptions || orderType.identifierNameOptions.length === 0) {
			console.log('No identifier name options');
			this.checkoutAdvanceStep();
		}
		return currentCheckoutStep;
	}

	selectOrderType(orderType: OOOrderType) {
		this.kioskService.activeOrder.value.orderType = orderType.key;
		this.kioskService.activeOrder.next(this.kioskService.activeOrder.value);
		this.checkoutFooterButtonDisabled = false;
	}

	startNewOrder() {
		console.log('start new order');
	}

	submitFinalOrder() {}
}

enum CheckoutStep {
	START = 'start',
	ORDER_TYPE_SELECT = 'orderTypeSelect',
	PROMO_CODE_SELECT = 'promoCodeSelect',
	IDENTIFIER_INPUT = 'identifierInput',
	PAYMENT_REQUEST = 'paymentRequest',
	AWAIT_PAYMENT = 'awaitPayment',
}
